import { fmtMoneda } from './moneda';
import { fmtFecha } from './fecha';
import { marcaImpresion } from './marca';
import { imprimirHTML, escHtml } from './imprimir';

// En la base donde_pago sigue siendo 'RU' (Remesas filtra por ese valor y las
// comisiones cambian de estado según dónde pagó). Solo la etiqueta visible es "Oficina".
export const etiquetaDondePago = (d) => (d === 'RU' ? 'Oficina' : (d || ''));


// Recibo de pago en oficina. datos:
// { numRecibo, fecha, monto, formaPago, cliente, polizaNum, aseguradora, ramo,
//   cuotas: [{ num, monto, parcial }], notas, registradoPor, reimpresion }
// `reimpresion: true` marca la copia (botón "Reimprimir recibo" del detalle de cobros).
// Los textos van escapados (escHtml): segunda capa, además de la impresión aislada.
export function imprimirReciboCobro(datos) {
  const fmt$ = fmtMoneda;
  const M = marcaImpresion();
  const filas = [
    ['Cliente', datos.cliente || '—'],
    ['Póliza', datos.polizaNum || '—'],
    ['Aseguradora', datos.aseguradora || '—'],
    ['Ramo', datos.ramo || '—'],
    ['Fecha de pago', fmtFecha(datos.fecha) || '—'],
    ['Forma de pago', datos.formaPago || '—'],
  ].filter(([, v]) => v && v !== '—');
  const cuotasHtml = (datos.cuotas || []).length ? `
    <div class="sub">Aplicado a</div>
    <table><thead><tr><th>Cuota</th><th class="r">Monto aplicado</th></tr></thead><tbody>
    ${datos.cuotas.map(c => `<tr><td>Cuota #${c.num || '—'}${c.parcial ? ' (parcial)' : ''}</td><td class="r">${fmt$(c.monto)}</td></tr>`).join('')}
    </tbody></table>` : '';
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Recibo ${datos.numRecibo || ''}</title>
    <style>
      body{font-family:Arial,sans-serif;font-size:12px;color:#111;margin:28px;max-width:520px}
      .brand{display:flex;align-items:center;gap:10px;margin-bottom:14px;border-bottom:2px solid ${M.colores.steel};padding-bottom:10px}
      .brand-name{font-size:16px;font-weight:800;color:${M.colores.steel};letter-spacing:1px;text-transform:uppercase}
      .brand-tag{font-size:10px;color:${M.colores.sky}}
      h1{font-size:15px;margin:0;color:${M.colores.steel}}
      .numrec{font-family:monospace;font-size:16px;font-weight:800;color:${M.colores.sky}}
      .head{display:flex;justify-content:space-between;align-items:flex-end;margin-bottom:14px}
      .monto{border:2px solid ${M.colores.steel};border-radius:8px;padding:10px 16px;margin:14px 0;display:flex;justify-content:space-between;align-items:center}
      .monto .ml{font-size:11px;color:#555;text-transform:uppercase;letter-spacing:1px}
      .monto .mv{font-size:22px;font-weight:800;color:${M.colores.steel}}
      .grid{display:grid;grid-template-columns:1fr 1fr;gap:6px 18px;margin-bottom:8px}
      .cl{font-size:9px;color:#666;text-transform:uppercase;letter-spacing:1px}
      .cv{font-size:12px;font-weight:600}
      .sub{font-size:11px;font-weight:700;color:${M.colores.steel};margin:12px 0 4px}
      table{width:100%;border-collapse:collapse;font-size:11px}
      th{background:${M.colores.steel};color:#fff;padding:5px 8px;text-align:left}
      td{padding:4px 8px;border-bottom:1px solid #e6e6e6}
      .r{text-align:right}
      .reimp{font-size:10px;font-weight:800;color:#b45309;border:1px solid #b45309;border-radius:4px;padding:1px 6px;margin-left:6px;vertical-align:middle;letter-spacing:1px}
      .notas{margin-top:10px;font-size:11px;color:#555}
      .firmas{display:flex;gap:40px;margin-top:56px}
      .firma{flex:1;text-align:center}
      .firma .linea{border-top:1px solid #111;margin-bottom:5px}
      .firma .fn{font-size:11px;font-weight:700;color:#111}
      .firma .fl{font-size:9px;color:#666;text-transform:uppercase;letter-spacing:1px;margin-top:2px}
      .pie{margin-top:26px;border-top:1px solid #ccc;padding-top:8px;font-size:10px;color:#777;display:flex;justify-content:space-between}
      @media print{body{margin:14px}}
    </style></head><body>
    <div class="brand">${M.logo}<div><div class="brand-name">${M.nombre}</div><div class="brand-tag">${M.tagline}</div></div></div>
    <div class="head">
      <h1>Recibo de Pago${datos.reimpresion ? ' <span class="reimp">REIMPRESIÓN</span>' : ''}</h1>
      <div><div class="cl">N° de recibo</div><div class="numrec">${datos.numRecibo || '—'}</div></div>
    </div>
    <div class="grid">
      ${filas.map(([l, v]) => `<div><div class="cl">${l}</div><div class="cv">${escHtml(v)}</div></div>`).join('')}
    </div>
    <div class="monto"><span class="ml">Monto recibido</span><span class="mv">${fmt$(datos.monto)}</span></div>
    ${cuotasHtml}
    ${datos.notas ? `<div class="notas"><strong>Notas:</strong> ${escHtml(datos.notas)}</div>` : ''}
    <div class="firmas">
      <div class="firma">
        <div class="linea"></div>
        ${datos.registradoPor ? `<div class="fn">${escHtml(datos.registradoPor)}</div>` : ''}
        <div class="fl">Firma de quien recibe el pago</div>
      </div>
      <div class="firma">
        <div class="linea"></div>
        <div class="fl">Sello</div>
      </div>
    </div>
    <div class="pie"><span>Pago recibido en oficina — ${M.nombre}</span><span>${datos.reimpresion ? 'Reimpreso' : 'Generado'}: ${fmtFecha(new Date())}</span></div>
    </body></html>`;
  imprimirHTML(html);
}
